import type { LocalDate } from '@zg-rentals/ts-ad-management-client';

export const formatLocalDate = (date: LocalDate) => {
  return `${date.month}-${date.day}-${date.year}`;
};
